var map = {
	"./fonbet.webp": "e386",
	"./lamoda.webp": "3eac",
	"./ligastavok.webp": "3d6a",
	"./mts.webp": "6deb",
	"./my-games-cloud.webp": "0e39",
	"./paribet.webp": "4cc4",
	"./perfect-world.webp": "d70c",
	"./stoloto.webp": "6558",
	"./warface.webp": "c47d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ebbf";